import { TypedLinkField } from './TypedLinkField';
import type { TopicDetails } from '@/types/topic';

export const FlyerUrlsField = (p: { details: TopicDetails; langs: string[]; onChange: (d: TopicDetails) => void }) => (
  <TypedLinkField {...p} linkType="flyer" label="Flyer URLs" urlPlaceholder="https://…/flyer.pdf" />
);
